module.exports = __webpack_public_path__ + "static/leda-homecare-young-person-care-40ae168dd9f8c2268044e0937f504b13.png";